module.exports = __webpack_public_path__ + "img/620.No_coffee_beans.1f7e8c67.svg";